export enum CellPhoneNumberBlocker {
    UsCountryCode = 'US',
    CanadaCountryCode = 'CA',
    VerificationTypePhone = 'Phone'
}
